<style lang="less" scoped>
    @import url('./css.less');
</style>
<template>
    <div class="container">
        <div class="map" ref="map"></div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    import 'echarts-gl';
    import loadMapData from './loadMapData';
    import deaultPropsValue from './default-props-value';
    export default {
        name: '',
        data() {
            return {

            }
        },
        watch: {
            name: function () {
                loadMapData(this.name).then((data) => {
                    echarts.registerMap(this.name, data);
                    this.initMap();
                })
            }
        },
        mixins: [deaultPropsValue],
        methods: {
            initMap() {
                const myChart = echarts.init(this.$refs.map);
                const option = {
                    geo3D: {
                        map: this.name,
                        roam: true,
                        itemStyle: {
                            color: "#1d1d84",
                            opacity: 1,
                            borderWidth: 0.8,
                            borderColor: "#09093f"
                        },
                        label: {
                            show: false,
                        },
                        emphasis: { //当鼠标放上去  地区区域是否显示名称
                            itemStyle: {
                                color: "#1d1d84",
                            },
                            label: {
                                show: true,
                                textStyle: {
                                    color: '#fff',
                                    fontSize: 20,
                                    backgroundColor: 'rgba(0,23,11,0)'
                                }
                            },
                            areaColor: "#09093f"
                        },
                        viewControl: {
                            distance: 80
                        },
                        light: {
                            main: {
                                color: '#fff', //光照颜色
                                intensity: 1.2, //光照强度
                                // shadowQuality: 'high', //阴影亮度
                                shadow: true, //是否显示阴影
                                //                        alpha: 55,
                                beta: 10

                            },
                            ambient: {
                                intensity: 0.3
                            }
                        }
                    },

                }

                myChart.setOption(option);
            }
        },
        mounted() {

            loadMapData(this.name).then((data) => {
                echarts.registerMap(this.name, data);
                this.initMap();
            })

        }
    }
</script>